<script setup lang="ts">
useReveal()
</script>

<template>
  <div>
    <SiteNav />
    <main>
      <HeroSection />
      <PitchSection />
      <ProductsSection />
      <HowItWorks />
      <SecuritySection />
      <ScreensShowcase />
      <HubsSection />
      <EarningsCalculator />
      <SocialProof />
      <FaqSection />
      <CtaSection />
    </main>
    <SiteFooter />
  </div>
</template>
